import { Navigate, createFileRoute, useRouter } from '@tanstack/react-router';
import { NotFoundPage } from '../../features/common/components/not-found-page';
import { menuItems } from '../../features/common/menu';
import { canAccessRoutePath } from '../../features/common/route-permission';

export const Home = () => {
  const router = useRouter();
  const { permissions } = Route.useRouteContext();
  const targetPath = menuItems
    .flatMap((item) => {
      if ('children' in item) {
        return item.children.map(({ path }) => path);
      }

      return item.path.startsWith('/') ? [item.path] : [];
    })
    .find((path) => canAccessRoutePath(router, path, permissions));

  if (!targetPath) {
    return <NotFoundPage />;
  }

  return <Navigate to={targetPath} replace />;
};

export const Route = createFileRoute('/_creator-center/')({
  component: Home,
});
